module.exports = __webpack_public_path__ + "static/media/Gilroy-UltraLight.32ebe7bd.woff2";